var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPen = function SvgPen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_1208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.195 20.5226L21.2841 10.0235C23.1273 8.2784 22.9849 5.18912 20.9697 3.20814C19.0021 1.27382 16.0011 1.1409 14.2667 2.91125L3.47994 13.9213C3.47994 13.9213 5.86944 14.872 7.54871 16.5228C9.22795 18.1735 10.195 20.5226 10.195 20.5226Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.61258 22.4817L10.1889 20.5315C10.1889 20.5315 9.22398 18.1816 7.54624 16.5293C5.8685 14.877 3.47987 13.9242 3.47987 13.9242L1.48798 21.3472C1.31445 21.9938 1.96356 22.6487 2.61258 22.4817Z",
    stroke: "currentColor",
    strokeWidth: 1.71429,
    vectorEffect: "non-scaling-stroke",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_1208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};

export { SvgPen as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzMzOF8xMjA4KSI+CjxwYXRoIGQ9Ik0xMC4xOTUgMjAuNTIyNkwyMS4yODQxIDEwLjAyMzVDMjMuMTI3MyA4LjI3ODQgMjIuOTg0OSA1LjE4OTEyIDIwLjk2OTcgMy4yMDgxNEMxOS4wMDIxIDEuMjczODIgMTYuMDAxMSAxLjE0MDkgMTQuMjY2NyAyLjkxMTI1TDMuNDc5OTQgMTMuOTIxM0MzLjQ3OTk0IDEzLjkyMTMgNS44Njk0NCAxNC44NzIgNy41NDg3MSAxNi41MjI4QzkuMjI3OTUgMTguMTczNSAxMC4xOTUgMjAuNTIyNiAxMC4xOTUgMjAuNTIyNloiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjEuNzE0MjkiIHZlY3Rvci1lZmZlY3Q9Im5vbi1zY2FsaW5nLXN0cm9rZSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yLjYxMjU4IDIyLjQ4MTdMMTAuMTg4OSAyMC41MzE1QzEwLjE4ODkgMjAuNTMxNSA5LjIyMzk4IDE4LjE4MTYgNy41NDYyNCAxNi41MjkzQzUuODY4NSAxNC44NzcgMy40Nzk4NyAxMy45MjQyIDMuNDc5ODcgMTMuOTI0MkwxLjQ4Nzk4IDIxLjM0NzJDMS4zMTQ0NSAyMS45OTM4IDEuOTYzNTYgMjIuNjQ4NyAyLjYxMjU4IDIyLjQ4MTdaIiBzdHJva2U9ImN1cnJlbnRDb2xvciIgc3Ryb2tlLXdpZHRoPSIxLjcxNDI5IiB2ZWN0b3ItZWZmZWN0PSJub24tc2NhbGluZy1zdHJva2UiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzMzOF8xMjA4Ij4KPHJlY3Qgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";